// import PropTypes from 'prop-types'
import React, { Component } from 'react'

import '../styles/App.css';
import '../styles/About.css';

export default class About extends Component {
  

  render() {
    return (
      <section id="sobre" className="container-about animate__animated animate__slideInUp">
        <h3>Quem sou eu?</h3>
        <div className="container-info">
          <p className="paragraph-1">Sou de Minas Gerais. Com uma sólida experiência de mais de 4 anos na área comercial, atualmente fiz uma transição em minha carreira para desenvolvimento web. Tenho lidado com React, JavaScript e Node.js. Estou estudando Desenvolvimento Web FullStack, e Análise e Desenvolvimento de Sistemas </p>

          <p className="paragraph-2">Nos meus momentos de descontração, encontro satisfação em jogar jogos de sobrevivência e cooperativos, o que estimula minha mente estratégica e meu espírito colaborativo. Sou também uma entusiasta de streaming e adoro compartilhar experiências e interagir com a comunidade online.</p>

          {/* <p className="paragraph-3">Desde que comecei a explorar o mundo do desenvolvimento web, tenho me apaixonado cada vez mais por essa área. Decidi investir nessa paixão e ingressei na Trybe, uma instituição reconhecida que tem me proporcionado um aprendizado prático e aprofundado. Estou desenvolvendo habilidades em linguagens de programação, frameworks e ferramentas que são essenciais para o mercado de trabalho atual.</p> */}
        </div>
      </section>
    )
  };
};
